import { IPrice } from '../../i18n/price/IPrice';
import { trackWithBing } from '../shared/trackers/trackWithBing';
import { adaptPriceToTrackingValue } from './adapters/adaptPriceToTrackingValue';

interface IBingRevenueEvent {
	totalRevenue: IPrice;
	currency: string;
}

export function trackBingRevenue({
	totalRevenue,
	currency,
}: IBingRevenueEvent) {
	// See: https://help.ads.microsoft.com/#apex/ads/en/56687/2
	trackWithBing('event', 'purchase', {
		revenue_value: adaptPriceToTrackingValue(totalRevenue),
		currency,
	});
}
